import TokenService from './token.service';

export default {
  addAuthTokenInterceptor,
  clearCache,
  removeEmptyParams,
};

function addAuthTokenInterceptor(config) {
  config.params = {
    ...config.params,
    token: TokenService.getAuthToken(),
  };
  return config;
}

function removeEmptyParams(config) {
  // Remove falsey values from the request params
  config.params = _.pickBy(config.params, _.identity);
  return config;
}

function clearCache(cache) {
  return (response) => {
    const cacheRemoveMethods = ['post', 'put', 'patch', 'delete'];
    if (cacheRemoveMethods.some(method => method === response.config.method)) {
      cache.reset();
    }
    return response;
  };
}
